module.exports = __webpack_public_path__ + "img/banner-default.6ee1a04e.jpg";